import { generateUuid } from '@zurich-framework/core/utils';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useSessionStorage } from '@zurich/common/hooks';
import { vsgaStepConfig } from '~/components/stepConfig';
import { activeStepAtom, vsgaPayloadAtom } from '~/state';

export function usePersistState() {
  const router = useRouter();

  const activeStep = useRecoilValue(activeStepAtom);
  const [payload, setPayload] = useRecoilState(vsgaPayloadAtom);

  const isNotLastStep = activeStep < vsgaStepConfig.length - 1;
  const [session, setSession] = useSessionStorage('vsga-payload', payload);

  useEffect(() => {
    const queryID = router.query.id;
    if (typeof payload.id === 'undefined' && typeof queryID === 'undefined') {
      const id = generateUuid();
      router.query.id = id;
      setPayload((self) => ({ ...self, id }));
      setSession((self) => ({ ...self, id }));
    }
    // Set only if query id has not been set yet
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const queryID = router.query.id;
    if (
      session.id &&
      session.id !== 'undefined' &&
      (typeof queryID === 'string' || typeof queryID === 'undefined') &&
      payload?.id === session?.id
    ) {
      router.query.id = session.id;
      setPayload(session);
    }

    // We get the payload from sessionStorage with the
    // initial load here. Thus, only check for session id changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session.id, payload.id]);

  useEffect(() => {
    if (payload.id && isNotLastStep) {
      setSession((prevSession) => {
        if (prevSession !== payload) {
          return payload;
        }
        return prevSession;
      });
    }
  }, [isNotLastStep, payload, setSession]);
}
